// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"f10b01e9","453":"10d0282a"}[chunkId] + ".chunk.js";
};